import addReportCommitTypes from './commit-types';

const INITIAL_ADD_REPORT_STATE = { isLoading: [] };

function addReportReducers(state = INITIAL_ADD_REPORT_STATE, action)  {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case addReportCommitTypes.RESET_ADD_REPORT_STATE:
      return { ...INITIAL_ADD_REPORT_STATE };
    case addReportCommitTypes.SET_ADD_REPORT_IS_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    default:
      return state;
  }
}

export default addReportReducers;
